import addCustomUserAgentHeader from 'utils/addCustomUserAgentHeader';
import baseFetch, { createParamString } from '../baseFetch';

export const fetchRegionalFeedUrl = (subregionId, start, limit, includeLocalNews) =>
  `/feed/regional?${createParamString({
    subregionId,
    start,
    limit,
    includeLocalNews,
  })}`;

export const fetchRegionalArticles = async (
  subregionId,
  start,
  limit,
  includeLocalNews,
  isServer = false,
) =>
  baseFetch(fetchRegionalFeedUrl(subregionId, start, limit, includeLocalNews), {
    headers: { ...addCustomUserAgentHeader(isServer) },
  });
